import { render, staticRenderFns } from "./DevModelModalDrawer.vue?vue&type=template&id=5a8dbb66&scoped=true&"
import script from "./DevModelModalDrawer.vue?vue&type=script&lang=js&"
export * from "./DevModelModalDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DevModelModalDrawer.vue?vue&type=style&index=0&id=5a8dbb66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8dbb66",
  null
  
)

export default component.exports